
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psti-related",
      function () {
        return require("private-next-pages/psti-related/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/psti-related"])
      });
    }
  